const user = {
  computed: {
    user() {
      const raw = localStorage.getItem('user')
      if (!raw) return null
      try {
        return JSON.parse(raw)
      } catch {
        try {
          const decoded = atob(raw)
          const user = JSON.parse(decoded)

          localStorage.setItem('user', JSON.stringify(user))
          return user
        } catch {
          return null
        }
      }
    },
  },
}

export default user
